export const getSharepointThemeColor = (colorKey)=>window["__themeState__"]?.theme?.[colorKey];
/** Relates to number of CSS color classes defined in @ms/uno-controls/.../common/GroupsColors */ export const NumGroupColors = 14;
(function(Colors) {
    Colors.White = "#FFFFFF";
    Colors.LightRed = "#e73550";
    Colors.DarkRed = "#a80000";
    Colors.Red = "#C4314B";
    Colors.Black = "#000000";
    Colors.Grey4 = "#0A0A0A";
    Colors.Grey14 = "#242424";
    Colors.Grey16 = "#292929";
    Colors.Grey26 = "#424242";
    Colors.Grey38 = "#616161";
    Colors.Grey46 = "#757575";
    Colors.Grey78 = "#C7C7C7";
    Colors.Grey82 = "#D1D1D1";
    Colors.Grey84 = "#D6D6D6";
    Colors.Grey92 = "#EBEBEB";
    Colors.Grey94 = "#F0F0F0";
    Colors.Grey96 = "#F5F5F5";
    Colors.Grey98 = "#FAFAFA";
    Colors.DarkGrey24 = "#3D3D3D";
    Colors.DarkGrey68 = "#ADADAD";
    Colors.Teams12 = "#bdbde6";
    Colors.Teams60 = "#444791";
    Colors.Teams70 = "#4F52B2";
    Colors.Teams80 = "#5B5FC7";
    Colors.Teams160 = "#E8EBFA";
    Colors.PmaSoftViolet = "#8B5CF6";
    Colors.PmaPurple = "#6453E4";
    Colors.gradientColor1 = "#B377E0";
    Colors.gradientColor2 = "#5166D7";
    Colors.PastelPink = "#FBDDF0";
    Colors.NeutralDark = "#201f1e";
    Colors.NeutralPrimary = "#323130";
    Colors.NeutralPrimaryAlt = "#3b3a39";
    Colors.NeutralSecondary = "#605e5c";
    Colors.NeutralSecondaryAlt = "#8a8886";
    Colors.NeutralTertiary = "#a19f9d";
    Colors.NeutralTertiaryAlt = "#c8c6c4";
    Colors.NeutralLight = "#edebe9";
    Colors.NeutralLighter = "#f3f2f1";
    Colors.NeutralLighterAlt = "#faf9f8";
    Colors.NeutralQuaternaryAlt = "#e1dfdd";
    Colors.ThemePrimary = "#217346";
    Colors.ThemeSecondary = "#318456";
    Colors.ThemeSecondaryAlt = "#4a986d";
    Colors.ThemeTertiary = "#62ab83";
    Colors.ThemeLighter = "#cee9da";
    Colors.PlannerPrimary = "#107c41";
    Colors.PlannerSecondary = "#218D51";
    Colors.PlannerDarkAlt = "#0F703B";
    Colors.PlannerDarker = "#094624";
    Colors.PlannerDarkDarker = "#60BD82";
    Colors.PlannerDarkPrimary = "#10893C";
    Colors.PlannerDarkSecondary = "#0F7937";
    Colors.DarkThemeAppBackgroundColor = "#1b1a19";
    Colors.HighContrastYellow = "#ffff00";
    Colors.HighContrastCyan = "#00ffff";
    Colors.HighContrastBlack = "#000000";
    Colors.HighContrastSelectedTextBackground = "#008000";
    Colors.HighContrastWhiteSelectedTextBackground = "#37006e";
    Colors.HighContrastBlackSelectedTextBackground = "#1aebff";
    Colors.ExcelIconColor = "#107c10";
    Colors.PowerPointIconColor = "#d24726";
    Colors.WordIconColor = "#2b579a";
    Colors.OneNoteIconColor = "#80397b";
    Colors.PdfIconColor = "#de3d41";
    Colors.ProjectIconColor = "#31752f";
    Colors.VisioIconColor = "#3955a3";
    Colors.FormsIconColor = "#038387";
    Colors.GenericIconColor = "#5e727c";
    Colors.MeetingNotesColorLight = "#7719aa";
    Colors.MeetingNotesColorDark = "#C0AAE4";
    Colors.WordColorLight = "#185abd";
    Colors.WordColorDark = "#296FE6";
    Colors.ExcelColorLight = "#107C41";
    Colors.ExcelColorDark = "#10893C";
    Colors.PowerPointColorLight = "#C43E1C";
    Colors.PowerPointColorDark = "#CA5010";
    Colors.ProjectColorLight = "#107C41";
    Colors.ProjectColorDark = "#0a4e28";
    Colors.TeamsPurple = "#5b5fc6";
    Colors.TeamsDarkPurple = "#7579eb";
    Colors.TeamsDarkBackground = "#252423";
    Colors.TeamsDarkNeutralPrimary = "#323130";
    Colors.TeamsAppBrand00 = "#5b5fc6";
    Colors.TeamsAppBrand04 = "#464775";
    Colors.TeamsAppBrand08 = "#7579eb";
    Colors.TeamsAppBrand12 = "#bdbde6";
    Colors.TeamsAppBrand14 = "#e2e2f6";
    Colors.TeamsContrastSelectedColor = "#00ebff";
    Colors.TeamsContrastHyperlinkColor = "#e6e600";
    Colors.TeamsHoverBackgroundColor = "#f5f5f5";
    Colors.TeamsLightBackgroundColor = "#f3f2f1";
    Colors.TeamsDarkBackgroundColor = "#201f1f";
    Colors.TeamsContrastPlaceHolderOrDisabledColor = "#3ef23e";
    Colors.TeamsTitleBackgroundColor = "#f9f8f7";
    Colors.TeamsButtonHoverColor = "#7679bf";
    Colors.TeamsLightPivotDownColor = "#bdbde6";
    Colors.TeamsMessageDarkColor = "#7a7fea";
    Colors.TeamsProgressNotStartedColor = "#605e5c"; // Grey
    Colors.TeamsProgressInProgressColor = "#327eaa"; // Blue
    Colors.TeamsProgressCompleteColor = "#418040"; // Green
    Colors.TeamsProgressLateColor = "#d13438"; // Salmon
    Colors.TeamsDarkProgressNotStartedColor = "#979693"; // Grey
    Colors.TeamsDarkProgressInProgressColor = "#5ca9e5"; // Blue
    Colors.TeamsDarkProgressCompleteColor = "#62ab83"; // Green
    Colors.TeamsDarkProgressLateColor = "#d13438"; // Salmon
    Colors.TeamsPriorityUrgentColor = "#D13438"; // Red
    Colors.TeamsPriorityImportantColor = "#D13438"; // Red
    Colors.TeamsPriorityMediumColor = "#0B6A0B"; // Green
    Colors.TeamsPriorityLowColor = "#0078D4"; // Blue
    Colors.TeamsDarkPriorityUrgentColor = "#F28C8C"; // Red
    Colors.TeamsDarkPriorityImportantColor = "#F28C8C"; // Red
    Colors.TeamsDarkPriorityMediumColor = "#67D48B"; // Green
    Colors.TeamsDarkPriorityLowColor = "#6CB8F6"; // Blue
    Colors.LoopBrand50 = "#560FBF";
    Colors.LoopBrand140 = "#D0BEFE";
    Colors.LoopBrand70 = "#7520F5";
    Colors.LoopBrand80 = "#8230FF";
    Colors.LoopBrand100 = "#A375FF";
    Colors.LoopBrand110 = "#AB85FF";
    Colors.FontColorThemeDark = "#195735";
    Colors.FontColorThemeDarkAlt = "#1e673f";
    Colors.FontColorThemeDarker = "#134027";
    Colors.FontColorThemeLight = "#a8d5bc";
    Colors.BorderColorNeutralPrimary = "#364147";
    Colors.BorderColorNeutralTertiaryAlt = "#c7cde1";
    Colors.BorderColorNeutralTertiary = "#afb8bd";
    Colors.SharepointTitleFontColor = ()=>getSharepointThemeColor("black") ?? Colors.Black;
    Colors.SharepointAddTaskButtonBackgroundColor = ()=>getSharepointThemeColor("neutralLighter") ?? Colors.NeutralLighter;
    Colors.SharepointBackgroundColor = ()=>getSharepointThemeColor("white") ?? Colors.White;
    Colors.SharepointTextFontColor = ()=>getSharepointThemeColor("primaryText") ?? "#333333";
    Colors.SharepointPlaceholderFontColor = ()=>getSharepointThemeColor("neutralTertiary") ?? Colors.NeutralTertiary;
    Colors.SharepointLightBackgroundColor = ()=>getSharepointThemeColor("neutralLight") ?? Colors.NeutralLight;
    Colors.SharepointNeutralTextFontColor = ()=>getSharepointThemeColor("neutralSecondary") ?? "#666666";
    Colors.SharepointButtonHoverColor = ()=>getSharepointThemeColor("themePrimary") ?? "#407855";
    Colors.SharepointCardSeparator = ()=>getSharepointThemeColor("neutralLight") ?? Colors.NeutralLight;
    Colors.SharepointBGColorForNonProcessableStyles = ()=>getSharepointThemeColor("PageBackground") ?? Colors.White;
    Colors.SharepointTextColorForNonProcessableStyles = ()=>getSharepointThemeColor("bodyText") ?? Colors.NeutralPrimary;
    Colors.SharepointBlueIconColor = ()=>getSharepointThemeColor("blue") ?? "#0078d4";
    Colors.SharepointCompleteColor = ()=>getSharepointThemeColor("excel") ?? Colors.ThemePrimary;
    Colors.SharepointHighPriIconColor = ()=>getSharepointThemeColor("redDark") ?? "#a4262c";
    Colors.SharepointCheckboxCheckedColor = ()=>getSharepointThemeColor("themePrimary") ?? "#6264A7";
    Colors.LoopLightP0 = "#712DFF";
    Colors.NeutralLightGrey14 = "#242424";
    Colors.NeutralLightGrey26 = "#424242";
    Colors.NeutralLightGrey30 = "#4D4D4D";
    Colors.NeutralLightGrey38 = "#616161";
    Colors.NeutralLightGrey44 = "#707070";
    Colors.NeutralLightGrey74 = "#BDBDBD";
    Colors.NeutralLightGrey82 = "#D1D1D1";
    Colors.NeutralLightGrey86 = "#DBDBDB";
    Colors.NeutralLightGrey88 = "#E0E0E0";
    Colors.NeutralLightGrey92 = "#EBEBEB";
    Colors.NeutralLightGrey94 = "#F0F0F0";
    Colors.NeutralLightGrey96 = "#F5F5F5";
    Colors.NeutralDarkGrey8 = "#141414";
    Colors.NeutralDarkGrey12 = "#1F1F1F";
    Colors.NeutralDarkGrey16 = "#292929";
    Colors.NeutralDarkGrey20 = "#333333";
    Colors.NeutralDarkGrey24 = "#3D3D3D";
    Colors.NeutralDarkGrey28 = "#474747";
    Colors.NeutralDarkGrey32 = "#525252";
    Colors.NeutralDarkGrey36 = "#5C5C5C";
    Colors.NeutralDarkGrey40 = "#666666";
    Colors.NeutralDarkGrey60 = "#999999";
    Colors.NeutralDarkGrey68 = "#ADADAD";
    Colors.NeutralDarkGrey84 = "#D6D6D6";
    Colors.CompleteButtonHoverColor = "#195735";
    Colors.ConfettiMagenta = "#e3008c";
    Colors.ConfettiRed = "#da3b00";
    Colors.ConfettiOrange = "#feab43";
    Colors.ConfettiGreen = "#02ad56";
    Colors.ConfettiBlue = "#0078d4";
    Colors.ConfettiPurple = "#8763b8";
    Colors.TeamsDarkThemeConfettiDarkPurple = "#7d84c4";
    Colors.NotStarted = "#605e5c"; // Grey
    Colors.InProgress = "#327eaa"; // Blue
    Colors.Completed = "#418040"; // Green
    Colors.Late = "#d13438"; // NOT Salmon
    Colors.LateHover = "#bc2f34"; // Dark NOT Salmon
    Colors.DarkNotStarted = "#979693"; // Grey
    Colors.DarkInProgress = "#5ca9e5"; // Blue
    Colors.DarkCompleted = "#62ab83"; // Green
    Colors.DarkLate = "#d13438"; // NOT Salmon
    Colors.ChartNotStarted = "#C3BAFF"; // Light purple
    Colors.ChartInProgress = "#4D43DE"; // Purple
    Colors.ChartLate = "#D33F4C"; // Red
    Colors.ChartCompleted = "#3ABB9F"; // Teal/Green
    Colors.ChartNotStartedInactive = "#F3F0FF"; // Pastel purple
    Colors.ChartInProgressInactive = "#E3DEFF"; // Pastel blue
    Colors.ChartLateInactive = "#F1BBBC"; // Pastel red
    Colors.ChartCompletedInactive = "#E3F7EF"; // Pastel green
    Colors.ChartNotStartedInactiveDark = "#1E155A"; // Dark purple
    Colors.ChartInProgressInactiveDark = "#130D3E"; // Dark blue
    Colors.ChartLateInactiveDark = "#200205"; // Dark red
    Colors.ChartCompletedInactiveDark = "#001919"; // Dark teal
    Colors.EvoPrimaryButtonBackgroundLight = "#6453E4";
    Colors.EvoPrimaryButtonBackgroundDark = "#4D43DE";
    Colors.EvoPrimaryButtonBackgroundHighContrast = "#ffffff";
    Colors.Urgent = "#d13438"; // Red
    Colors.Important = "#d13438"; // Red
    Colors.Medium = "#0B6A0B"; // Green
    Colors.Low = "#0078D4"; // Blue
    Colors.DarkUrgent = "#F28C8C"; // Red
    Colors.DarkImportant = "#F28C8C"; // Red
    Colors.DarkMedium = "#67D48B"; // Green
    Colors.DarkLow = "#6CB8F6"; // Blue
    Colors.LightCompletedSolidIcon = "#4A9F30";
    Colors.DarkCompletedSolidIcon = "#63B64C";
    Colors.ContrastCompletedSolidIcon = "#000000";
    Colors.PortfolioItemStatusDefault = "#767676"; // Gray
    Colors.PortfolioItemStatusNotStarted = "#767676"; // Dark Gray
    Colors.PortfolioItemStatusOnTrack = "#107C10"; // Green
    Colors.PortfolioItemStatusAtRisk = "#DA3B01"; // Orange
    Colors.PortfolioItemStatusOffTrack = "#C50F1F"; // Red
    Colors.PortfolioItemStatusClosed = "#0078D4"; // Blue
    Colors.DarkPortfolioItemStatusDefault = "#B3B3B3"; // Gray
    Colors.DarkPortfolioItemStatusNotStarted = "#B3B3B3"; // Gray
    Colors.DarkPortfolioItemStatusOnTrack = "#27AC22"; // Green
    Colors.DarkPortfolioItemStatusAtRisk = "#F87528"; // Orange
    Colors.DarkPortfolioItemStatusOffTrack = "#CC2635"; // Red
    Colors.DarkPortfolioItemStatusClosed = "#4FA1E1"; // Blue
    Colors.ContrastPortfolioItemStatusDefault = "#A6A6A6"; // Gray
    Colors.ContrastPortfolioItemStatusNotStarted = "#A6A6A6"; // Gray
    Colors.ContrastPortfolioItemStatusOnTrack = "#FFFFFF"; // Green
    Colors.ContrastPortfolioItemStatusAtRisk = "#8EE3F0"; // Orange
    Colors.ContrastPortfolioItemStatusOffTrack = "#8EE3F0"; // Red
    Colors.ContrastPortfolioItemStatusClosed = "#A6A6A6"; // Blue
    Colors.DelinkIconLight = "#c50f1f";
    Colors.DelinkIconDark = "#f1707b";
    Colors.DelinkIconHighContrast = "#0086f0";
//#endregion
})(Colors || (Colors = {}));
export var Colors;
